module.exports = __webpack_public_path__ + "static/media/Queenofpain.2e1f86f1.png";